module.exports = __webpack_public_path__ + "static/img/map.6890f74e.png";